import routerOptions0 from "/codebuild/output/src3507326296/src/luckywise/node_modules/.pnpm/nuxt@3.17.0_@parcel+watcher@2.5.1_@types+node@24.9.1_db0@0.3.4_eslint@9.38.0_jiti@2.6.1__iore_x6m2e4getqzqxazeuv2lo7fgai/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/codebuild/output/src3507326296/src/luckywise/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}